// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"561":"eabaab5a","684":"b4a69560"}[chunkId] + ".chunk.js";
};